import MotionTween from 'motion-tween';
import fetch from 'isomorphic-unfetch';
import { parents } from '../../../../util/dom';
import ViewManager from '../../../../managers/view';
import { tabletBreakpoint } from '../../../../constants/breakpoints';
import JraEncodeDecodeModule from './JraEncodeDecodeModule';
import { resetInputs } from '../helpers';

const API_KEY = 'BA79-RF99-TK77-HC18';// 'KJ77-AP39-AH18-XH99';

const ACTIVE_TOGGLE_CLASS = 'active';

const SHOW_ADDRESS_LIST_CLASS = 'JraAddressLookup-show';

export default class JraAddressLookup extends JraEncodeDecodeModule {
  constructor(element, encodeDecodeKey) {
    super(encodeDecodeKey);
    this.element = element;
    this.textInputToggleClass = 'textInput';
    this.postcodeRegExp = new RegExp(/^[A-Za-z]{1,2}[0-9][0-9A-Za-z]? ?[0-9][A-BD-HJLNP-UW-Za-bd-hjlnp-uw-z]{2}$/i);


    this.initJraAddressLookup();
  }

  encode(modules) {
    super.encode(modules);

    if (this.manualEntryButton.parentElement.classList.contains(ACTIVE_TOGGLE_CLASS)) {
      modules[this.key].showAddress = true;
    }
  }

  decode() {
    super.decode();

    const module = this.getEncodedSessionData();
    if (!module) return;

    if (module.showAddress) {
      this.showAddressDropdown();
    }
  }


  resetInputsOnLocateUpdate() {
    const module = this.getEncodedSessionData();
    if (!module) return;

    if (!module.showAddress && this.addressInputs) {
      resetInputs(this.addressInputs);
    }
  }


  initJraAddressLookup() {
    this.form = parents(this.element, '[data-form="form"]')[0];
    this.postcodeControl = this.element.querySelector('[data-jra-address-lookup="postcode-control"]');
    this.postcodeInput = this.element.querySelector('[data-jra-address-lookup="postcode-input"]');
    this.countryNameInput = this.element.querySelector('[data-jra-address-lookup="country-name-input"]');
    this.countryCodeInput = this.element.querySelector('[data-jra-address-lookup="country-code-input"]');
    this.postcodeSearchButton = this.element.querySelector('[data-jra-address-lookup="search-button"]');
    this.cancelButton = this.element.querySelector('[data-jra-address-lookup="cancel-button"]');
    this.clearPostcodeInput = this.element.querySelector('[data-jra-address-lookup="clear-postcode-input"]');
    this.manualEntryButton = this.element.querySelector('[data-jra-address-lookup="manual-entry-button"]');
    this.addressList = this.element.querySelector('[data-jra-address-lookup="address-list"]');
    this.addressListContainer = this.element.querySelector('[data-jra-address-lookup="address-list-container"]');

    this.addressListItems = null;

    this.switchPositionElements = [...this.element.querySelectorAll('[data-jra-form-switch-position]')];
    this.switchPositionElementsContainer = this.element.querySelector('[data-jra-form-switch-position-container]');

    this.resultContainer = this.element.querySelector('[data-jra-address-lookup="result-container"]');
    this.resultContainerInputs = [...this.resultContainer.querySelectorAll('[data-form="input"]')];
    this.resultAddress1 = this.element.querySelector('[data-jra-address-lookup="result-address-1"]');
    this.resultAddress2 = this.element.querySelector('[data-jra-address-lookup="result-address-2"]');
    this.resultAddress3 = this.element.querySelector('[data-jra-address-lookup="result-address-3"]');
    this.resultAddress4 = this.element.querySelector('[data-jra-address-lookup="result-address-4"]');
    this.resultTown = this.element.querySelector('[data-jra-address-lookup="result-town"]');
    this.resultCounty = this.element.querySelector('[data-jra-address-lookup="result-county"]');
    this.resultCountry = this.element.querySelector('[data-jra-address-lookup="result-country"]');
    this.resultPostcode = this.element.querySelector('[data-jra-address-lookup="result-postcode"]');

    this.addressInputs = [...this.form.querySelectorAll('[data-jra-form-address-input]')];

    this.isManualEntryActive
        = this.manualEntryButton.parentElement.classList.contains(ACTIVE_TOGGLE_CLASS);
    this.showContainerValidationCheckbox = this.element.querySelector('[data-jra-address-lookup="show-container-validation"]');

    if (this.showContainerValidationCheckbox) {
      if (!this.showContainerValidationCheckbox.dataset.jraAddressLookupIsOpen) {
        // force reset of hidden container validation, chrome can keep this check on pressing back
        this.showContainerValidationCheckbox.checked = false;
      }
    }

    if (this.postcodeInput) {
      this.postcodeInput.addEventListener('keyup', this.onKeyUp);
      this.postcodeInput.addEventListener('keydown', this.onKeyDown);
      this.postcodeInput.addEventListener('focus', this.onInputFocus);
      this.postcodeInput.addEventListener('click', this.stopDocumentBodyClick);
    }

    if (this.clearPostcodeInput) {
      this.clearPostcodeInput.addEventListener('click', this.clearInput);
    }

    if (this.countryNameInput) {
      this.countryCodeInput.addEventListener('change', this.onCountrySelect);
      this.onCountrySelect();
    }

    if (this.postcodeInput && this.postcodeSearchButton) {
      this.postcodeSearchButton.addEventListener('click', this.onPostcodeSearch);
    }

    if (this.manualEntryButton) {
      this.manualEntryButton.addEventListener('click', this.showAddressDropdown);
    }

    if (this.cancelButton) {
      this.cancelButton.addEventListener('click', this.onCancel);
    }

    // trigger onCountrySelect when user changes between UK & overseas membership options
    const formObserver = new MutationObserver((mutations) => {
      [...mutations].forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          this.onCountrySelect();
        }
      });
    });
    formObserver.observe(this.form, {
      attributes: true,
    });

    if (window.innerWidth < tabletBreakpoint) {
      this.switchElementPosition();
    }
    ViewManager.on(ViewManager.EVENT_UPDATE, this.onViewUpdate);
  }


  onInputFocus = () => {
    this.activate();
  }

  switchElementPosition = () => {
    const element2 = this.switchPositionElements[0];
    const element1 = this.switchPositionElements[1];
    const newElements = [element1, element2];

    this.switchPositionElements.forEach((element) => {
      this.switchPositionElementsContainer.removeChild(element);
    });

    newElements.forEach((element) => {
      this.switchPositionElementsContainer.appendChild(element);
    });

    this.switchPositionElements = newElements;
  }


  onKeyUp = () => { // need handling for other key presses, just for showing clear button I think
    if (this.postcodeInput.value === '') {
      this.postcodeControl.classList.remove(this.textInputToggleClass);
    } else {
      this.postcodeControl.classList.add(this.textInputToggleClass);
    }
  }


  onKeyDown = (event) => { // need handling for other key presses
    if (event.keyCode === 13) {
      event.preventDefault();
      this.onPostcodeSearch();
    }
  }


  onViewUpdate = (event) => {
    if (event.breakpointUpdate) {
      const isSearchFirstElement = this.switchPositionElements[0].dataset.jraFormSwitchPosition === 'search';
      if (ViewManager.hasTransitionedBelow(tabletBreakpoint) && isSearchFirstElement) {
        this.switchElementPosition();
      } else if (
        ViewManager.hasTransitionedAboveAndWithin(tabletBreakpoint)
        && !isSearchFirstElement
      ) {
        this.switchElementPosition();
      }
    }
  }


  clearInput = (event) => {
    if (event) {
      this.stopDocumentBodyClick(event);
    }
    this.postcodeInput.value = '';
    this.postcodeControl.classList.remove(this.textInputToggleClass);
    this.addressList.innerHTML = '';
  }


  showAddressDropdown = () => {
    let start = 0;
    let end = 0;

    if (!this.manualEntryButton.parentElement.classList.contains(ACTIVE_TOGGLE_CLASS)) {
      // all manual inputs given a tabindex of -1 until they are made visible
      this.resultContainerInputs.forEach((input) => {
        if (input.getAttribute('tabindex')) {
          input.removeAttribute('tabindex');
        }
      });
      this.manualEntryButton.parentElement.classList.add(ACTIVE_TOGGLE_CLASS);
      this.showContainerValidationCheckbox.checked = true;
      start = 0;
      this.resultContainer.style.height = 'auto';
      // eslint-disable-next-line
      window.getComputedStyle(this.resultContainer).opacity;
      end = this.resultContainer.offsetHeight;
      this.animate(start, end);
    }
  }


  onCountrySelect = () => {
    this.countryCode = this.countryCodeInput.value;
  }


  onCancel = () => {
    this.close();
  }


  onPostcodeSearch = (event) => {
    if (event) {
      this.stopDocumentBodyClick(event);
    }

    if (this.addressList.innerHTML !== '') {
      this.addressList.innerHTML = '';
    }

    const postcode = this.postcodeInput.value.replace(/\s/g, '');
    let url = `https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.10/json3.ws?Key=${API_KEY}&Text=${postcode}&IsMiddleWare=false`;
    if (this.countryCode !== '') {
      const urlExtension = `&Origin=${this.countryCode}&Countries=${this.countryCode}`;

      url += urlExtension;
    }

    fetch(url)
      .then(response => response.json())
      .then((data) => {
        this.onFindAddresses(data, this.postcodeInput.value);
      });
  }


  onAddressSelect = (index, postcode, event) => {
    if (event) {
      event.stopPropagation();
    }

    const addressItem = this.results[index];

    if (addressItem.Type === 'Address') {
      const url = `https://services.postcodeanywhere.co.uk/Capture/Interactive/Retrieve/v1.00/json3.ws?Key=${API_KEY}&Id=${addressItem.Id}`;

      fetch(url)
        .then(response => response.json())
        .then((data) => {
          this.onFindAddress(data);
        });
    } else if (addressItem.Type !== 'Address') {
      const url = `https://services.postcodeanywhere.co.uk/Capture/Interactive/Find/v1.00/json3.ws?Key=${API_KEY}&Container=${addressItem.Id}`;

      fetch(url)
        .then(response => response.json())
        .then((data) => {
          this.addressList.innerHTML = '';
          this.onFindAddresses(data, postcode);
        });
    }
  }


  onFindAddress = (data) => {
    if (data.Items.length === 0) {
      window.alert('No results found');
    } else {
      const address = data.Items.shift();
      this.resultAddress1.value = address.Line1;
      this.resultAddress2.value = address.Line2;
      this.resultAddress3.value = address.Line3;
      this.resultAddress4.value = address.Line4;
      this.resultTown.value = address.City;
      this.resultPostcode.value = address.PostalCode;
      this.resultCounty.value = address.ProvinceName || address.Province || '';

      this.showAddressDropdown();
      this.triggerInputChangeEvent();
      this.close();
    }
  }


  onFindAddresses = (addressData, postcode) => {
    if (addressData.Items.length === 0) {
      window.alert('No results found.');
    } else if (addressData.Items.length > 0) {
      if (addressData.Items[0].Error) {
        window.alert('please search for a postcode or address');
      } else {
        this.open();
        this.results = [];

        addressData.Items.forEach((item) => {
          this.createAddressItem(item.Text, item.Description, item.Type, postcode);
          this.results.push(item);
        });

        this.addressListItems = [...this.element.querySelectorAll('[data-jra-address-lookup="address-list-item"]')];
        this.addressListItems.forEach((item, index) => {
          item.addEventListener('click', event => this.onAddressSelect(index, postcode, event));
        });

        if (this.results.length === 1) {
          this.onAddressSelect(0, postcode);
        }

        const addressListFirstItem = this.addressListItems[0];
        const addressListFirstItemBox = addressListFirstItem.getBoundingClientRect();

        if (addressListFirstItem && addressListFirstItemBox.bottom < 0) {
          // if item is not an address then further filtering will occur
          // so we may need to scroll to the first item in the list.
          this.addressList.scrollTop = addressListFirstItemBox.top;
        }
      }
    }
  }


  createAddressItem = (itemText, itemDescription, itemType) => {
    let label1;
    let label2;

    if (itemType === 'Postcode') {
      label1 = itemDescription;
      label2 = itemText;
    } else if (itemType === 'Address' && this.countryCode === 'GB') {
      const firstCommaIndex = itemDescription.indexOf(',');
      const lastIndex = itemDescription.length;
      const areaText = itemDescription.substring(0, firstCommaIndex);

      label1 = `${itemText}, ${areaText}`;
      label2 = itemDescription.substring(firstCommaIndex + 2, lastIndex);
    } else {
      label1 = itemText;
      label2 = itemDescription;
    }

    const addressItemHtml = `
    <button class="JraAddressLookup_item" type="button" data-jra-address-lookup="address-list-item">
      <h6 class="JraAddressLookup_itemText">${label1}</h6>
      <h6 class="JraAddressLookup_itemText">${label2}</h6>
    </button>
    `;

    this.addressList.innerHTML += addressItemHtml;
  }


  animate(startValue, endValue) {
    if (this.motionTween !== undefined) {
      this.motionTween.destroy();
    }

    this.motionTween = new MotionTween({
      startValue,
      endValue,
      time: 175,
      update: this.onUpdateTween,
      complete: this.setActiveState,
      animatorType: MotionTween.animatorType.ease,
      animatorOptions: {
        easingFunction: MotionTween.easingFunction.easeInOutQuad,
      },
    }).start();
  }


  onUpdateTween = (value) => {
    this.resultContainer.style.height = `${value}px`;
  }


  setActiveState = () => {
    this.resultContainer.style.height = 'auto';
  }


  triggerInputChangeEvent() {
    [...this.resultContainer.querySelectorAll('[data-form*="input"]')].forEach(JraAddressLookup.triggerInput);
  }


  static triggerInput(input) {
    const event = document.createEvent('Event');
    event.initEvent('change', true, true);
    input.dispatchEvent(event);
  }


  activate() {
    this.postcodeControl.classList.add(ACTIVE_TOGGLE_CLASS);
  }


  open() {
    this.postcodeControl.classList.add(SHOW_ADDRESS_LIST_CLASS);
    document.body.addEventListener('click', this.onDocumentBodyClick);
  }


  close() {
    document.body.removeEventListener('click', this.onDocumentBodyClick);
    this.clearInput();
    this.postcodeControl.classList.remove(SHOW_ADDRESS_LIST_CLASS);
    this.postcodeControl.classList.remove(ACTIVE_TOGGLE_CLASS);
    this.postcodeInput.focus();
  }


  onDocumentBodyClick = () => {
    this.close();
  }


  stopDocumentBodyClick = (event) => {
    event.stopPropagation();
  }
}
